import { CLIENT_PRIMARY_TABS, CLIENT_SETTINGS_SECTIONS, CLIENT_TECHNICAL_SECTIONS, type ClientPrimaryTab, type ClientSettingsSection, type ClientTechnicalSection } from "../../lib/clientsAdminLayout.mjs";

interface ClientNavigationProps {
  activeTab: ClientPrimaryTab;
  onTabChange: (tab: ClientPrimaryTab) => void;
  activeTechnicalSection?: ClientTechnicalSection;
  onTechnicalSectionChange?: (section: ClientTechnicalSection) => void;
  activeSettingsSection?: ClientSettingsSection;
  onSettingsSectionChange?: (section: ClientSettingsSection) => void;
}

export default function ClientNavigation({ activeTab, onTabChange, activeTechnicalSection = "messaging", onTechnicalSectionChange, activeSettingsSection = "experience-pdpa", onSettingsSectionChange }: ClientNavigationProps) {
  return (
    <>
      <nav className="flex overflow-x-auto border-b border-slate-200 px-4" aria-label="Sections du client">
        {CLIENT_PRIMARY_TABS.map((tab) => (
          <button key={tab.id} type="button" aria-current={activeTab === tab.id ? "page" : undefined} onClick={() => onTabChange(tab.id)} className={`whitespace-nowrap border-b-2 px-4 py-3 text-sm font-medium ${activeTab === tab.id ? "border-primary text-primary" : "border-transparent text-slate-500"}`}>
            {tab.label}
          </button>
        ))}
      </nav>
      {activeTab === "settings" && (
        <nav className="flex gap-2 overflow-x-auto border-b bg-slate-50 p-3" aria-label="Réglages du client">
          {CLIENT_SETTINGS_SECTIONS.map((section) => (
            <button key={section.id} type="button" aria-current={activeSettingsSection === section.id ? "page" : undefined} onClick={() => onSettingsSectionChange?.(section.id)} className={`whitespace-nowrap rounded-lg px-3 py-2 text-sm ${activeSettingsSection === section.id ? "bg-primary text-white" : "bg-white text-slate-600"}`}>{section.label}</button>
          ))}
        </nav>
      )}
      {activeTab === "technical" && (
        <nav className="flex gap-2 overflow-x-auto border-b p-3 lg:hidden" aria-label="Configuration technique">
          {CLIENT_TECHNICAL_SECTIONS.map((section) => (
            <button key={section.id} type="button" aria-current={activeTechnicalSection === section.id ? "page" : undefined} onClick={() => onTechnicalSectionChange?.(section.id)} className={`whitespace-nowrap rounded-lg px-3 py-2 text-sm ${activeTechnicalSection === section.id ? "bg-primary text-white" : "bg-slate-100 text-slate-600"}`}>{section.label}</button>
          ))}
        </nav>
      )}
    </>
  );
}

export function ClientTechnicalSidebar({ activeSection, onChange }: { activeSection: ClientTechnicalSection; onChange: (section: ClientTechnicalSection) => void }) {
  return <nav className="mr-6 hidden min-h-[28rem] w-52 shrink-0 float-left border-r bg-slate-50 p-3 lg:block" aria-label="Configuration technique">{CLIENT_TECHNICAL_SECTIONS.map((section) => <button key={section.id} type="button" aria-current={activeSection === section.id ? "page" : undefined} onClick={() => onChange(section.id)} className={`mb-1 block w-full rounded-lg px-3 py-2 text-left text-sm ${activeSection === section.id ? "bg-primary text-white" : "text-slate-600 hover:bg-slate-100"}`}>{section.label}</button>)}</nav>;
}
